// hooks/useClientFetch.js
'use client'
import { useContext, useState, useEffect, useRef } from 'react'
import { RetryContext } from '@/components/ErrorBoundary'
import { createClientService } from '@/lib/http/client'

export default function useClientFetch(options) {
    const {
        apiName,
        initialData,
        initialError,
        params,
        shouldAbort = true,
        v = '1.0'
    } = options

    const [data, setData] = useState(initialData)
    const [error, setError] = useState(initialError || null)
    const retryKey = useContext(RetryContext)
    const controllerRef = useRef(null)

    const fetchData = async (signal) => {
        try {
            const api = createClientService()
            const response = await api.get(
                apiName,
                { data: params, signal },
                { v }
            )
            setData(response)
            setError(null)
            return response
        } catch (err) {
            if (!signal?.aborted) {
                setError(err)
            }
            throw err
        }
    }

    useEffect(() => {
        if (initialError) setError(initialError)
    }, [initialError])

    useEffect(() => {
        setData(initialData);
        // 重置错误状态，允许客户端重试
        setError(null);
    }, [initialData]);

    useEffect(() => {
        // 移除错误检查的返回语句
        // if (error) return

        const controller = new AbortController()
        if (shouldAbort) {
            controllerRef.current?.abort()
            controllerRef.current = controller
        }

        const execute = async () => {
            try {
                // 修改条件：当没有数据或存在错误时发起请求
                if (!data || error) {
                    await fetchData(controller.signal)
                }
            } catch (err) {
                console.error('Fetch error:', err)
            }
        }

        execute()

        return () => controller.abort()
    }, [retryKey, error]) // 保持对error的依赖

    return { data, error, refetch: fetchData }
}